module.exports = __webpack_public_path__ + "img/jesper.a4b1f326.png";